import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { BgColorOptions, ColorOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ShellComponent } from '@df/ui/common/shell/shell.component';

export namespace NCmsProductViewSimpleCarousel {
    export const BLOCK_ID = 'product-view-simple-carousel';

    export interface IBlockData extends Catalog.IBlockData<IBlockContent> {}

    export interface IBlockContent {
        title: string;
        cards: ICard[];
    }

    export interface ICard {
        image: string;
        title: string;
        subtitle?: string;
        description: string;
        background?: string;
        color?: string;
    }
}

@Component({
    selector: 'product-view-cms-simple-carousel',
    templateUrl: './product-view-cms-simple-carousel.html',
    styleUrls: ['./product-view-cms-simple-carousel.scss'],
    standalone: true,
    imports: [ICmsClientModule, CarouselModule, NgClass, ShellComponent, ImageModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductViewCmsSimpleCarouselBlock>({
    id: NCmsProductViewSimpleCarousel.BLOCK_ID,
    name: 'Product view simple carousel',
    onDemandOnly: true,
    hidePreview: true,
    block: {
        url: NCmsProductViewSimpleCarousel.BLOCK_ID
    },
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'cards',
            title: 'Cards',
            itemName: 'Card',
            itemNameField: 'title',
            required: true,
            fields: [
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'subtitle',
                    title: 'Subtitle'
                },
                {
                    type: NICmsContentField.EFieldType.textarea,
                    key: 'description',
                    title: 'Description',
                    required: true
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'background',
                    options: BgColorOptions,
                    previewMode: 'color',
                    title: 'Background color'
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'color',
                    options: ColorOptions,
                    previewMode: 'color',
                    title: 'Text color'
                }
            ]
        }
    ]
})
export class ProductViewCmsSimpleCarouselBlock extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'componentOrBlockContent'
    })
    content!: NCmsProductViewSimpleCarousel.IBlockContent;

    @Input()
    variant?: string;

    @Input()
    addWrap: boolean = false;
}
